export class ServiceEventTransactionHistoryItem {
    constructor(
        public Application_AssociationDate: Date,

        public Application_AccountingPeriod: string,

        public Application_TransactionType: string,

        public Application_TransactionTypeDescription: string,

        public TransactionDetails: string,

        public Payer_ProcessorIdentifier: string,

        public Payer_ProcessorControlNumber: string,

        public Payer_PlanCode: string,

        public Payer_PFMStandardPayerIdentifier: string,

        public Deposit_CheckNumber: string,

        public Deposit_DepositDate: Date,

        public Application_GLCode: string,

        public Money_TransactionAmount: number,

        public Money_ReceivableAmountAmount: number,

        public Money_UnappliedAmount: number,

        public ServiceEventId: string,

        public RawDataImport_ShardClaimIdentifier: string,

        public Payment_ReferenceNumber: string,

        public Application_Source: string,

        public Application_SessionNumber: string,

        public Application_PolicyCode: string,

        public Application_PolicyDescription: string,

        public Payer_ShardPayerGroupIdentifier: string,

        public Application_ReferenceNumber: number,
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/serviceEventTransactionHistoryItem.model.ts